import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.2,
			y: 21.2,
			className: "icon-fill-primary",
			width: 42.5,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M43.1 34.1v2.3c-2.9 0-3.8-5-5.2-13.8-.7-4.1-1.8-10.9-2.9-11.8-1.2 1.2-2.3 9.5-3 15.1C30.5 38.1 29.5 43 26.8 43s-3.7-5.6-5.2-20.4c-.7-6.6-1.7-16.4-3-18.2-1.2 1.5-2.2 9.5-2.9 14.9-1.6 12.1-2.5 17.1-5.2 17.1s-3.8-5-5.2-13.8c-.7-4.2-1.8-11.1-3-11.8V8.6c2.9 0 3.8 5 5.2 13.8.7 4.1 1.8 10.9 2.9 11.8 1.2-1.2 2.3-9.5 3-15C14.7 6.9 15.6 2 18.4 2s3.7 5.6 5.2 20.4c.7 6.6 1.7 16.4 3 18.2 1.2-1.5 2.2-9.6 2.9-15C31 13.5 32 8.5 34.8 8.5s3.8 5 5.2 13.8c.8 4.2 1.9 11.1 3.1 11.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M42 2.5c.3 0 .5.2.5.5v39c0 .3-.2.5-.5.5H3c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h39M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
		})
	]
});
export default SvgIcon;
